// Browser-owned retry correlation for chat POSTs. The id is not authority; the server binds it to its
// authenticated Actor, owned Session and bounded-message hash and rejects any changed replay.

import { mintTransportRequestId } from './transport-request-id.ts';

export interface PendingChatRequest {
  readonly requestId: string;
  readonly message: string;
  readonly localTurnId: string;
  sessionId: string | null;
}

/** Fail closed if the browser cannot mint a cryptographically random RFC 4122 v4 identity. */
export function mintChatRequestId(): string {
  try {
    return mintTransportRequestId();
  } catch {
    throw new Error('secure chat request identity is unavailable');
  }
}

/** Only an unconfirmed same-Session/same-message retry may reuse the uncertain request identity. */
export function reusablePendingChatRequest(
  pending: PendingChatRequest | null,
  sessionId: string | null,
  message: string,
): PendingChatRequest | undefined {
  if (pending === null || pending.message !== message) return undefined;
  if (pending.sessionId !== null && pending.sessionId !== sessionId) return undefined;
  return pending;
}
